<cc-top-bar [title]="'RECHARGABLE_CONFIRMATION' | translate"></cc-top-bar>
<cc-payment-spinner *ngIf="spinner"></cc-payment-spinner>

<cc-payment-confirmer
  [activeCard]="activeCard"
  [paymentParams]="paymentParams"
  [user]="user"
  (confirmed)="onConfirm($event)">
</cc-payment-confirmer>
